// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/upload/style/index.less
// module id = 1165
// module chunks = 1